import { createTheme } from "@mui/material/styles";

export const buildMuiTheme = (tokens = {}) => {
  const colors = tokens.colors || {};
  const typography = tokens.typography || {};
  const components = tokens.components || {};

  return createTheme({
    palette: {
      primary: {
        main: colors.primary || "#1976d2",
      },
      secondary: {
        main: colors.secondary || "#9c27b0",
      },
      background: {
        default: colors.background || "#ffffff",
      },
      text: {
        primary: colors.text?.primary || "#000000",
        secondary: colors.text?.secondary || "#666666",
        disabled: colors.text?.disabled || "#999999",
      },
      border: {
        default: colors.border?.default || "#cccccc",
        hover: colors.border?.hover || "#cccccc",
        active: colors.border?.active || "#cccccc",
      },
    },

    typography: {
      fontFamily: typography.fontFamily || "Roboto, sans-serif",

      h1: {
        fontWeight: typography.headingWeight || 600,
      },
      h2: {
        fontWeight: typography.headingWeight || 600,
      },
      h3: {
        fontWeight: typography.headingWeight || 600,
      },
      h5: {
        fontWeight: typography.headingWeight || 600,
      },

      body1: {
        fontWeight: typography.bodyWeight || 400,
        fontSize: typography.body1?.fontSize || "16px",
      },
      body2: {
        fontWeight: typography.bodyWeight || 400,
      },
    },

    shape: {
      borderRadius: components?.button?.borderRadius ? parseInt(components.button.borderRadius) : 4,
    },

    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: components?.button?.borderRadius || "4px",
            padding: components?.button?.padding || "6px 16px",
            textTransform: "none",
          },
        },
      },
      border: {
        default: components?.border?.default || "1px",
        hover: components?.border?.hover || "1px",
        active: components?.border?.active || "2px",
      },
    },
  });
};
